'use client'
import type { ReactNode, ButtonHTMLAttributes, InputHTMLAttributes,
  SelectHTMLAttributes, TextareaHTMLAttributes } from 'react'
import { createContext, useContext, useEffect, useId, useRef, useState } from 'react'
import { cx } from '../utils'

// ── Card ──

export function Card({
  children,
  className,
  padding = true,
}: {
  children: ReactNode
  className?: string
  padding?: boolean
}) {
  return (
    <div
      className={cx(
        'rounded-sm border border-line bg-surface shadow-[var(--shadow-xs)]',
        padding && 'p-5',
        className,
      )}
    >
      {children}
    </div>
  )
}
